import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Media from "react-media";
import { NavLink } from "react-router-dom";
import { Image, Table, Form } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { ExperienceTableHead } from "./ExperienceTableHead";
import moment from "moment";
import { useSelector } from "react-redux";
import { amApi } from "../../../../api/apiHelper";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import ExpRequestBodyCard from "./ExpRequestBodyCard";
import NoContent from "../../../reusableComponents/NoContentComponent";
import ExpDashboardIcons from "./ExpDashboardIcons";
import { successAlert } from "../../../../function/alert";
import { SmallLoader } from "../../../Loader/SmallLoader";
import ExpFilterSection from "./ExpFilterSection";
import { disabled } from "express/lib/application";
import { TopDateField } from "../../Orders/OrderDashboard/OrderDashboard";
import _ from "lodash";
import sortAlphaNumeric from "../../../../function/sortAlphaNumeric";
import PaxFilter from "../../../reusableComponents/paxFilter";
import ExpRequestBodyCardMobile from "./ExpRequestBodyCardMobile";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import filterDinnersByPax from "../../../../function/experiencePaxFilter";
const seatingNew = require("../../../../assets/images/seatingImages/ticketbooked.png");
const pendingNew = require("../../../../assets/images/seatingImages/pendingexp.png");
const historyNew = require("../../../../assets/images/seatingImages/historyexp.png");

const CuratedDashboardDetails = ({ ...props }) => {
  const history = useHistory();
  const id = history?.location?.pathname?.split("/")[2];
  const page = history?.location?.pathname?.split("/")[3];
  const [exp, setExp] = useState({});
  const [search, setSearch] = useState("");
  const [filterSeatingValue, setSeatingStatusValue] = useState("");
  const [seatingPaymentType, setSeatingPaymentType] = useState("");
  const [seatingPaymentStatus, setSeatingPaymentStatus] = useState("");
  const vendor = useSelector((state) => state.auth.user.VendorUser);
  const [expRequests, setExpRequests] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [onSetDate, selectOnSetDate] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [seeAllOpen, setSeeAllOpen] = useState(false);
  const [groupByData, setGroupByData] = useState({ show: false });
  const paxOptions = [2, 4, 6, 8, "All"];
  const [paxFilter, setPaxFilter] = useState(null);

  const onChangeDate = (date) => {
    selectOnSetDate(date);
  };

  const onClickSetSelectedDateClick = () => {
    setSelectedDate(onSetDate);
  };

  useEffect(() => {
    let finalDate = moment().format("YYYY-MM-DD");
    selectOnSetDate(finalDate);
    setSelectedDate(finalDate);
  }, []);
  const iconIndex = { pending: 0, booking: 1, history: 2 };
  const [iconData, setIconData] = useState([
    {
      count: 0,
      link: `/curatedDashboard/${id}/pending`,
      icon: pendingNew,
      code: "pending",
      name: "Pending",
      showNotification: true,
    },
    {
      count: 0,
      link: `/curatedDashboard/${id}/booking`,
      icon: seatingNew,
      code: "booking",
      name: "Ticket Booked",
      showNotification: true,
    },
    {
      count: 0,
      link: `/curatedDashboard/${id}/history`,
      icon: historyNew,
      code: "history",
      name: "History",
      showNotification: false,
    },
  ]);

  const onStatusChange = async (type, formData, id) => {
    let patch = await amApi.patch(`/expRequest/${id}`, formData);
    let iconD = [...iconData];
    let data = [...expRequests];
    if (type !== page) {
      data = data.filter(
        (ele) => ele._id.toString() !== patch?.data?._id.toString()
      );
      iconD[iconIndex[type]].count += 1;
      iconD[iconIndex[page]].count -= 1;
    } else {
      let index = data.findIndex((obj) => obj._id == patch?.data?._id);
      data[index] = patch?.data;
    }
    setExpRequests(data);
    setIconData(iconD);
    successAlert("Updated Successfully");
  };

  async function fetchOpenData() {
    let response = await amApi.get(
      `/expRequest?expId=${exp._id}&status=${page}`
    );
    setExpRequests(response.data);
    let newData = _.groupBy([...response.data], (data) =>
      moment(data["reservationTime"]).format("ll")
    );
    for (let key in newData) {
      let data = _.groupBy(newData[key], (data) =>
        moment(data["reservationTime"]).format("hh A")
      );
      let newSort = Object.keys({ ...data }).sort(sortAlphaNumeric);
      newData[key] = { data: data, sortOrder: newSort };
    }
    let newSortOrder = Object.keys({ ...newData }).sort(sortAlphaNumeric);
    setGroupByData({ sortOrder: newSortOrder, data: newData, show: true });
  }

  useEffect(() => {
    async function fetchData() {
      let date;
      if (selectedDate) {
        date = new Date(selectedDate).getTime();
      }
      let response = await amApi.get(
        `/expRequest?expId=${exp._id}&status=${page}&dateTime=${date}`
      );
      let stats = await amApi.get(
        `/expRequest?expId=${exp._id}&type=STATS&dateTime=${date}`
      );
      let icnData = [...iconData];
      icnData[0].count = stats?.data?.[0]?.pendingCount || 0;
      icnData[1].count = stats?.data?.[0]?.bookingCount || 0;
      icnData[2].count = stats?.data?.[0]?.historyCount || 0;
      setIconData(icnData);
      setExpRequests(response.data);
    }
    if (vendor && exp._id && !seeAllOpen) {
      fetchData();
    } else if (seeAllOpen) {
      fetchOpenData();
    }
  }, [page, exp, selectedDate, seeAllOpen]);

  useEffect(() => {
    async function fetchData() {
      let expD = await amApi.get(`/experience/${id}`);
      setExp(expD.data);
      if (expD.data) {
        setDisabled(false);
        if (
          (expD.data?.expType === "CURATED" && expD.data.seatsLeft <= 0) ||
          (!expD.data.sameDayBooking &&
            moment(expD.data.endDate)
              .startOf("day")
              .diff(moment().startOf("day"), "days") <= 0) ||
          moment(expD.data.endDate)
            .startOf("day")
            .diff(moment().startOf("day"), "days") < 0 ||
          !expD.data.active
        ) {
          setDisabled(true);
        }
      }
    }
    if (id) fetchData();
  }, [id]);

  let filteredData = expRequests;
  if (search) {
    let searchData = new RegExp(search, "i");
    filteredData = expRequests.filter((getall) => {
      if (searchData.test(getall?.userDetails?.name)) {
        return getall;
      } else if (searchData.test(getall?.requestId)) {
        return getall;
      } else {
        return false;
      }
    });
  }

  filteredData = filterDinnersByPax(filteredData, paxFilter);

  if (filterSeatingValue === "Not Seated") {
    filteredData = expRequests.filter(
      (dinner) => dinner.status === "NOTSEATED"
    );
  }
  if (filterSeatingValue === "Seated") {
    filteredData = expRequests.filter((dinner) => dinner.status === "SEATED");
  }
  if (seatingPaymentType) {
    filteredData = expRequests.filter(
      (dinner) => dinner.paymentData?.paymentMethod === seatingPaymentType
    );
  }
  if (seatingPaymentStatus) {
    filteredData = expRequests.filter(
      (dinner) => dinner.paymentData?.paymentStatus === seatingPaymentStatus
    );
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="right-side-panel">
            <Media query="(max-width: 992px)">
              <RightSideNavigation />
            </Media>
            <Media query="(min-width: 992px)">
              <RightSideNavigation
                history={history}
                leftText={"history"}
                displayText={"Back"}
                pageTitle={"Events Dashboard"}
              />
            </Media>
            <Media query="(min-width: 992px)">
              <>
                <div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-between align-items-center col-8">
                      <ExpDashboardIcons
                        data={iconData}
                        page={page}
                        exp={exp}
                        history={history}
                      />
                      <div style={{ minWidth: "200px" }}>
                        <div>
                          <span
                            className="f12-500"
                            style={{ fontWeight: "bold" }}
                          >
                            {exp?.name || ""}
                          </span>
                        </div>
                        <span className="f9-400" style={{ color: "#EE3A23" }}>
                          Experience ID: {exp?.expId || ""}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end align-items-center col-4">
                      {page === "booking" && (
                        <>
                          <TopDateField
                            date={onSetDate}
                            changeDate={(date) => onChangeDate(date)}
                            onButtonClickSetDate={() =>
                              onClickSetSelectedDateClick()
                            }
                          />
                          <div>
                            <button
                              className={
                                seeAllOpen === false
                                  ? "btn btn-link f15-500 "
                                  : "btn btn-link f15-500 text-red"
                              }
                              type="button"
                              onClick={() => setSeeAllOpen(!seeAllOpen)}
                            >
                              {seeAllOpen ? "Close All Open" : "See All Open"}
                            </button>
                          </div>
                        </>
                      )}
                      <div className="col text-right">
                        <button
                          onClick={() =>
                            history.push("/curated/addGuests", exp)
                          }
                          className="btn"
                          disabled={disabled}
                        >
                          <Image
                            alt="add"
                            title="add"
                            width="40px"
                            src={require("../../../../assets/images/seatingImages/add-button.svg")}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 d-flex justify-content-between align-items-center">
                  <div className="col-8">
                    <div className="d-flex justify-content-between align-items-center">
                      <div
                        className={`newexpandablesearch mr-2 active `}
                        style={{ maxWidth: "420px" }}
                      >
                        <div className="searchicon">
                          <i
                            className="fa fa-search"
                            aria-hidden="true"
                            style={{ fontSize: "20px" }}
                          ></i>
                        </div>
                        <div className="input">
                          <Form.Control
                            type="text"
                            className="newsearchinput"
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                            style={{ borderRadius: "28px" }}
                          />
                          <i className="fa fa-timesw" aria-hidden="true"></i>
                        </div>
                      </div>
                      <PaxFilter
                        options={paxOptions}
                        selected={paxFilter}
                        setSelected={setPaxFilter}
                      />
                    </div>
                  </div>
                  <div
                    className="px-3 col-3"
                    style={{ borderLeft: "1px solid #E0E0E0", width: "20vw" }}
                  >
                    <div className="f9-500  py-2">Experience Date & Time</div>
                    <div className="row">
                      <div className="col-6 py-2">
                        <div className="f9-400 opacity5">Start Date</div>
                        <div className="f12-700">
                          {moment(exp?.startDate).format("Do MMM YYYY")}
                        </div>
                      </div>
                      <div className="col-6 py-2">
                        <div className="f9-400 opacity5">End Date</div>
                        <div className="f12-700">
                          {moment(exp?.endDate).format("Do MMM YYYY")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="m-0" />
                <div className="row mt-4">
                  <div className={"col-12 p-0"}>
                    <div className="col-12 p-0  user-table-reusable-superadmin font_16_r">
                      <Table>
                        <thead>
                          <ExperienceTableHead />
                        </thead>
                        {!filteredData ? (
                          <SmallLoader />
                        ) : filteredData?.length == 0 ? (
                          <NoContent />
                        ) : groupByData?.show && seeAllOpen ? (
                          Object.keys(groupByData.data).map((keyName, j) => (
                            <>
                              <div className="today-date-dropdown-seating-dashboard">
                                <div>
                                  <h4>{groupByData.sortOrder[j]}</h4>
                                </div>
                              </div>
                              {Object.keys(
                                groupByData.data[groupByData.sortOrder[j]]?.data
                              ).map((keyN, i) => (
                                <>
                                  <div className="today-date-dropdown-seating-dashboard">
                                    <div>
                                      <h4>
                                        {`${
                                          groupByData.data[
                                            groupByData.sortOrder[j]
                                          ]?.sortOrder[i].split(" ")[0]
                                        } : 00 ${
                                          groupByData.data[
                                            groupByData.sortOrder[j]
                                          ]?.sortOrder[i].split(" ")[1]
                                        }`}
                                      </h4>
                                    </div>
                                    <div className="seating-dashboard-today-line">
                                      <hr className="line" />
                                    </div>
                                  </div>
                                  {groupByData.data[
                                    groupByData.sortOrder[j]
                                  ]?.data[
                                    groupByData.data[groupByData.sortOrder[j]]
                                      ?.sortOrder[i]
                                  ].map((expRequest) => (
                                    <ExpRequestBodyCard
                                      expRequest={expRequest}
                                      page={page}
                                      onStatusChange={onStatusChange}
                                    />
                                  ))}
                                </>
                              ))}
                            </>
                          ))
                        ) : (
                          filteredData?.map((expRequest) => (
                            <ExpRequestBodyCard
                              expRequest={expRequest}
                              page={page}
                              onStatusChange={onStatusChange}
                            />
                          ))
                        )}
                      </Table>
                    </div>
                  </div>
                </div>
              </>
            </Media>
            <Media query="(max-width: 992px)">
              <div style={{ marginTop: "18%" }}>
                <div className="row px-4">
                  <div className="col-9">
                    <div>
                      <span className="f12-500" style={{ fontWeight: "bold" }}>
                        {exp?.name || ""}
                      </span>
                    </div>
                    <span className="f9-400" style={{ color: "#EE3A23" }}>
                      Experience ID: {exp?.expId || ""}
                    </span>
                  </div>

                  <div className="col-3">
                    <button
                      onClick={() => history.push("/curated/addGuests", exp)}
                      className="btn"
                      disabled={disabled}
                    >
                      <Image
                        alt="add"
                        title="add"
                        width="40px"
                        src={require("../../../../assets/images/seatingImages/add-button.svg")}
                      />
                    </button>
                  </div>
                </div>
                <ExpDashboardIcons
                  data={iconData}
                  page={page}
                  exp={exp}
                  history={history}
                />
                <div className="d-flex justify-content-between align-items-center col-12 mt-3">
                  {page === "booking" && (
                    <>
                      <TopDateField
                        date={onSetDate}
                        changeDate={(date) => onChangeDate(date)}
                        onButtonClickSetDate={() =>
                          onClickSetSelectedDateClick()
                        }
                      />
                      <div>
                        <button
                          className={
                            seeAllOpen === false
                              ? "btn btn-link f15-500 "
                              : "btn btn-link f15-500 text-red"
                          }
                          type="button"
                          onClick={() => setSeeAllOpen(!seeAllOpen)}
                        >
                          {seeAllOpen ? "Close All Open" : "See All Open"}
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <hr />
                <div className="d-flex justify-content-between align-items-center mt-4 container-fluid">
                  <div
                    className={`newexpandablesearch mr-2 active `}
                    style={{ maxWidth: "420px" }}
                  >
                    <div className="searchicon">
                      <i
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </div>
                    <div className="input">
                      <Form.Control
                        type="text"
                        className="newsearchinput"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                        style={{ borderRadius: "28px" }}
                      />
                      <i className="fa fa-timesw" aria-hidden="true"></i>
                    </div>
                  </div>
                  <PaxFilter
                    options={paxOptions}
                    selected={paxFilter}
                    setSelected={setPaxFilter}
                    className="py-1"
                  />
                </div>
                <div className="px-3 col-12 mt-3">
                  <div className="f12-500 pt-2">Experience Date & Time</div>
                  <div className="row">
                    <div className="col-6 py-2">
                      <div className="f12-400 opacity5">Start Date</div>
                      <div className="f14-700">
                        {moment(exp?.startDate).format("Do MMM YYYY")}
                      </div>
                    </div>
                    <div className="col-6 py-2">
                      <div className="f12-400 opacity5">End Date</div>
                      <div className="f14-700">
                        {moment(exp?.endDate).format("Do MMM YYYY")}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="mt-3 row text-center align-items-center py-2"
                  style={{ backgroundColor: "#fff2d5" }}
                >
                  <div className="col-4 f14-500">Name</div>
                  <div className="col-3 f14-500">Total PAX</div>
                  <div className="col-5 f14-500">
                    <div className="d-flex align-items-center">
                      <div>
                        Date/Time <br /> Timer
                      </div>
                      <div>
                        <div className="ml-2" style={{ cursor: "pointer" }}>
                          <Image
                            alt="Sort"
                            title="Sort"
                            width="20px"
                            src={require("../../../../assets/images/iconButton/ntimer.png")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {filteredData?.map((expRequest) => (
                    <ExpRequestBodyCardMobile
                      expRequest={expRequest}
                      page={page}
                      onStatusChange={onStatusChange}
                      key={expRequest?.requestId}
                    />
                  ))}
                </div>

                <div className="bottom-panel">
                  <BottomNavigationMobile />
                </div>
              </div>
            </Media>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CuratedDashboardDetails;
